document.documentElement.classList.remove('no-js');

function fsnOrganizeProducts() {
  const seen = new Set();
  const sections = document.querySelectorAll('[data-fsn-product-section]');

  sections.forEach((section) => {
    const batch = Number.parseInt(section.getAttribute('data-fsn-max-visible') || '999', 10);
    const currentLimit = Number.parseInt(section.getAttribute('data-fsn-current-visible') || String(batch), 10);
    const dedupe = section.getAttribute('data-fsn-dedupe') === 'true';
    const cards = Array.from(section.querySelectorAll('.fsn-product-card[data-fsn-product-handle]'));
    const eligible = [];

    cards.forEach((card) => {
      const handle = card.getAttribute('data-fsn-product-handle');
      const duplicate = dedupe && handle && seen.has(handle);
      card.removeAttribute('data-fsn-hidden-limit');
      card.removeAttribute('data-fsn-hidden-dedupe');

      if (duplicate) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
        card.setAttribute('data-fsn-hidden-dedupe', 'true');
        return;
      }

      if (dedupe && handle) seen.add(handle);
      eligible.push(card);
    });

    eligible.forEach((card, index) => {
      if (index >= currentLimit) {
        card.hidden = true;
        card.setAttribute('aria-hidden', 'true');
        card.setAttribute('data-fsn-hidden-limit', 'true');
      } else {
        card.hidden = false;
        card.removeAttribute('aria-hidden');
      }
    });

    const visibleCount = Math.min(currentLimit, eligible.length);
    section.setAttribute('data-fsn-visible-products', String(visibleCount));

    if (visibleCount === 0 && !(window.Shopify && window.Shopify.designMode)) {
      section.hidden = true;
    } else {
      section.hidden = false;
    }

    let loadWrap = section.querySelector('.fsn-load-more-products-wrap');
    if (eligible.length > currentLimit) {
      if (!loadWrap) {
        loadWrap = document.createElement('div');
        loadWrap.className = 'fsn-load-more-products-wrap';
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'fsn-load-more-products';
        button.textContent = 'CARGAR MÁS PRODUCTOS';
        button.addEventListener('click', () => {
          const now = Number.parseInt(section.getAttribute('data-fsn-current-visible') || String(batch), 10);
          section.setAttribute('data-fsn-current-visible', String(now + batch));
          fsnOrganizeProducts();
        });
        loadWrap.appendChild(button);
        const carouselWrap = section.querySelector('.fsn-carousel-wrap');
        if (carouselWrap) carouselWrap.insertAdjacentElement('afterend', loadWrap);
        else section.appendChild(loadWrap);
      }
    } else if (loadWrap) {
      loadWrap.remove();
    }
  });
}

function fsnInitAutoCarousels() {
  document.querySelectorAll('.fsn-carousel').forEach((carousel) => {
    if (carousel.dataset.fsnAutoInit === 'true') return;
    carousel.dataset.fsnAutoInit = 'true';
    let paused = false;

    ['mouseenter', 'focusin', 'touchstart'].forEach((evt) => {
      carousel.addEventListener(evt, () => { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach((evt) => {
      carousel.addEventListener(evt, () => { paused = false; }, { passive: true });
    });

    window.setInterval(() => {
      if (paused) return;
      const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth - 4);
      if (maxScroll <= 0) return;
      const step = Math.max(280, Math.round(carousel.clientWidth * 0.82));
      if (carousel.scrollLeft >= maxScroll) carousel.scrollTo({ left: 0, behavior: 'smooth' });
      else carousel.scrollBy({ left: step, behavior: 'smooth' });
    }, 5200);
  });
}

function fsnBoot() {
  fsnOrganizeProducts();
  fsnInitAutoCarousels();
}

document.addEventListener('DOMContentLoaded', fsnBoot);
document.addEventListener('shopify:section:load', fsnBoot);
document.addEventListener('shopify:section:reorder', fsnBoot);

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-mobile-menu-toggle]');
  if (menuButton) {
    const nav = document.querySelector('[data-mobile-nav]');
    if (nav) { const open = nav.classList.toggle('is-open'); menuButton.setAttribute('aria-expanded', open ? 'true' : 'false'); }
  }



  const mobileParentLink = event.target.closest('.fsn-nav-item.has-dropdown > a');
  if (mobileParentLink && window.matchMedia('(max-width: 760px)').matches) {
    const item = mobileParentLink.parentElement;
    event.preventDefault();
    const wasOpen = item.classList.contains('is-expanded');
    document.querySelectorAll('.fsn-nav-item.has-dropdown.is-expanded').forEach((other) => {
      if (other !== item) other.classList.remove('is-expanded');
    });
    item.classList.toggle('is-expanded', !wasOpen);
  }

  const scrollButton = event.target.closest('[data-carousel-dir]');
  if (scrollButton) {
    const id = scrollButton.getAttribute('data-carousel-target');
    const carousel = document.getElementById(id);
    if (!carousel) return;
    const dir = scrollButton.getAttribute('data-carousel-dir') === 'next' ? 1 : -1;
    carousel.scrollBy({ left: dir * Math.max(320, carousel.clientWidth * 0.75), behavior: 'smooth' });
  }
});
